import Swiper, {Pagination, Navigation, Zoom, Lazy, Autoplay} from 'swiper';
import "swiper/css";
import "swiper/css";
import "swiper/css/zoom";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/lazy";
import Inputmask from "inputmask";

//Большой слайдер на главной
new Swiper(".js-promo-slider", {
    modules: [Pagination, Navigation, Zoom, Lazy, Autoplay],
    preloadImages: false,
    lazy: {
        loadPrevNext: true,
    },
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".promo-slider__arrow_next",
        prevEl: ".promo-slider__arrow_prev",
    },
    pagination: {
        el: ".promo-slider__pagination",
        clickable: true,
    },
});
//Слайдер ТМ и Лицензии
new Swiper(".js-promo-carousel", {
    modules: [Pagination, Navigation, Zoom, Lazy, Autoplay],
    preloadImages: false,
    lazy: {
        loadPrevNext: true,
    },
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 0,
    watchSlidesProgress: true,
    loop: true,
    autoplay: {
        delay: 7000,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".promo-carousel__arrow_next",
        prevEl: ".promo-carousel__arrow_prev",
    },
    pagination: {
        el: ".promo-carousel__pagination",
        clickable: true,
    },
    breakpoints: {
        1119: {
            slidesPerView: 6,
            slidesPerGroup: 3
        },
        767: {
            slidesPerView: 3,
            slidesPerGroup: 3
        }
    },
});
//Новинки
new Swiper(".js-product-carousel", {
    modules: [Pagination, Navigation, Zoom, Lazy],
    preloadImages: false,
    lazy: {
        loadPrevNext: true,
    },
    slidesPerView: 5,
    spaceBetween: 0,
    slidesPerGroup: 3,
    watchSlidesProgress: true,
    navigation: {
        nextEl: ".swiper-arrow-next",
        prevEl: ".swiper-arrow-prev",
    },
    breakpoints: {
        1119: {
            slidesPerView: 4,
        },
        1019: {
            slidesPerView: "auto",
        },
        320: {
            slidesPerView: 1,
        }
    },
});
//Ваши любимые категории
/*new Swiper(".js-category-carousel", {
    modules: [Pagination, Navigation, Zoom, Lazy],
    preloadImages: false,
    lazy: {
        loadPrevNext: true,
    },
    loop: true,
    slidesPerView: 6,
    spaceBetween: 0,
    watchSlidesProgress: true,
    navigation: {
        nextEl: ".swiper-arrow-next",
        prevEl: ".swiper-arrow-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        1199: {
            slidesPerView: 4
        },
        767: {
            slidesPerView: 2
        }
    }
});*/

//Слайдер сертификатов
new Swiper(".js-picture-carousel", {
    modules: [Pagination, Navigation, Zoom, Lazy],
    preloadImages: false,
    lazy: {
        loadPrevNext: true,
    },
    slidesPerView: 6,
    spaceBetween: 0,
    watchSlidesProgress: true,
    navigation: {
        nextEl: ".swiper-arrow-next",
        prevEl: ".swiper-arrow-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        1199: {
            slidesPerView: 4
        },
        767: {
            slidesPerView: 3
        }
    }
});

//Шаблон маски для ввода телефона
Inputmask({mask: "+7 (999) 999-99-99", showMaskOnHover: !1}).mask('input[data-required="tel"]');

//Схлопывание Хедера при прокрутке
const header = document.querySelector('.js-sticky');
const headerFix = document.querySelector('.js-head-fix');
let scrollTop = 0;

window.addEventListener('scroll', () => {
    let catalog = document.querySelector('.js-catalog-panel');
    scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop > 220) {
        header.classList.add('sticky');
        if (header.querySelector('.btn-feedback-director'))
            header.querySelector('.btn-feedback-director').style.display = 'none';
        headerFix.classList.remove('hidden');
        catalog.classList.remove('hidden');
    } else {
        header.classList.remove('sticky');
        if (header.querySelector('.btn-feedback-director'))
            header.querySelector('.btn-feedback-director').style.display = 'block';
        headerFix.classList.add('hidden');
        catalog.classList.add('hidden');
    }
});

//Миникорзина мобильной версии
const basketCount = document.querySelector('.navbar-mobile .cart-mini__count');
let ls = localStorage.getItem('igr_basket');
let oBasket = false;
if (ls.length > 0)
    oBasket = JSON.parse(ls);

if (basketCount != null) {
    if (typeof oBasket == 'object' && oBasket.value.count > 0) {
        basketCount.innerHTML = oBasket.value.count;
        basketCount.style.display = 'inline-block';
    } else {
        basketCount.style.display = 'none';
    }

    window.addEventListener('storage', changeBasket);
    document.addEventListener("updateBasket", changeBasket);

    function changeBasket(event) {
        if ('detail' in event && event.detail)
            basketCount.innerHTML = event.detail.count;
        else
            basketCount.innerHTML = event.count;
    };
}